export default __webpack_public_path__ + "img/75315d3d84719b44636d890a9ac5dad4.svg";